import { render } from "./MethInfo.vue?vue&type=template&id=4b3b2136"
import script from "./MethInfo.vue?vue&type=script&lang=js"
export * from "./MethInfo.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__